(function () {
  const replayIntervalMs = 5000;
  const enhancedRoots = new WeakSet();
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function replayAnimatedLogos(root) {
    if (reduceMotion.matches) return;

    const logos = root.querySelectorAll('[data-bs-replay-logo]');
    if (!logos.length) return;

    logos.forEach((logo, index) => {
      const baseSrc = logo.getAttribute('data-bs-base-src') || logo.getAttribute('src');
      if (!baseSrc) return;

      const replay = () => {
        const url = new URL(baseSrc, window.location.href);
        url.searchParams.set('replay', `${Date.now()}-${index}`);
        logo.setAttribute('src', url.toString());
      };

      window.setTimeout(replay, 450 + index * 180);
      window.setInterval(replay, replayIntervalMs);
    });
  }

  function enhanceTilt(root) {
    const targets = root.querySelectorAll('[data-bs-tilt]');
    if (!targets.length || reduceMotion.matches) return;

    targets.forEach((target) => {
      target.addEventListener('pointermove', (event) => {
        if (event.pointerType === 'touch') return;

        const rect = target.getBoundingClientRect();
        const x = ((event.clientX - rect.left) / rect.width) * 100;
        const y = ((event.clientY - rect.top) / rect.height) * 100;
        const tiltX = ((50 - y) / 50) * 2.2;
        const tiltY = ((x - 50) / 50) * 2.2;

        target.style.setProperty('--bs-x', `${x}%`);
        target.style.setProperty('--bs-y', `${y}%`);
        target.style.setProperty('--bs-tilt-x', `${tiltX}deg`);
        target.style.setProperty('--bs-tilt-y', `${tiltY}deg`);
      });

      target.addEventListener('pointerleave', () => {
        target.style.setProperty('--bs-x', '50%');
        target.style.setProperty('--bs-y', '50%');
        target.style.setProperty('--bs-tilt-x', '0deg');
        target.style.setProperty('--bs-tilt-y', '0deg');
      });
    });
  }

  function init(root) {
    const aboutRoot = root.matches && root.matches('[data-bs-about]') ? root : root.querySelector('[data-bs-about]');
    if (!aboutRoot || enhancedRoots.has(aboutRoot)) return;

    enhancedRoots.add(aboutRoot);
    replayAnimatedLogos(aboutRoot);
    enhanceTilt(aboutRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
